<template>

  <div class="modal-mask" v-show="showFieldModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <div class="container">
            <div class="row">
              <slot name="header">Свойства</slot>
              <button class="ml-4 p-0 btn btn-primary" @click="showFindFieldPart">
                find field
              </button>
            </div>
            <div class="row mt-2 pt-2 border-top" v-if="searchField">
              <div class="">
                <div class="col-12">
                  <span class="p-1 mr-2">
                    поиск класса
                  </span>
                  <input type="text" v-model="product_search" @keyup="searchProduct">
                </div>
                <div class="col-12 pt-3" v-if="product_prefetched.length > 0">
                  <span class="p-1 mr-2">
                    код класса
                  </span>
                  <select id="prefetched" v-model="product_id" @change="loadProductFields">
                    <option v-for="prod in product_prefetched" :key="prod.code" :value="prod.product_id">
                      {{prod.code}}
                    </option>
                  </select>
                </div>
                <div class="col-12 pt-3"  v-if="product_fields.length > 0">
                  выбрать поле класса
                  <select id="find_by_code" class="d-block" v-model="selectedField">
                    <option v-for="field in product_fields" :key="field.id" :value="field">
                      {{field.title}}
                    </option>
                  </select>
                  <button class="ml-1 p-1 btn btn-success" @click="applyField" :disabled="!selectedField"> Применить </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <ValidationObserver ref="fieldStoreValidate">
            <div class="d-flex justify-content-between">
              <div>Класс:</div>
              <div>{{ selectedProduct.code }} {{ selectedProduct.title }}</div>
            </div>
            <hr>
            <div class="form-group">
              <label>Предлагаемое наименование свойства</label>
              <select name="title_scaffold" class="form-control" v-model="field.ru_title">
                <option v-for="title in possibleTitles" :value="title" :key="title">{{title}}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Наименование свойства</label>
              <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
                <input type="text" class="form-control" v-model="field.ru_title"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Описание свойства</label>
              <input type="text" class="form-control" v-model="field.ru_comment"/>
            </div>
            <div class="form-group">
              <label>Единица измерения</label>
              <select class="form-control" v-model="field.unit_id">
                <option v-for="(unit, index) in units" :key="index"
                        :value="unit.id"
                        :selected="unit.id == field.unit_id"
                >{{ unit.title }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Обязательное свойство?</label>
              <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
                <select class="form-control" v-model="field.isRequired">
                  <option value="1">Да</option>
                  <option value="0">Нет</option>
                </select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Тип свойства (RADIO | CHECKBOX | TEXT | NUMBER | MULTISELECT)</label>
              <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
                <select class="form-control" v-model="field.inputType">
                  <option value="0" disabled>Выберите тип</option>
                  <option
                      v-for="fieldType in fieldTypes"
                      :value="fieldType.value"
                      :key="fieldType.id">
                    {{ fieldType.title }}
                  </option>
                </select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <!-- ******** RANGEBLOCK ******** -->
            <div id="RangeBlock" v-if="field.inputType === 'range'">
              <div class="w-100 d-flex justify-content-sm-between">
                <h4>RANGE</h4>
                <a class="btn btn-success cursor" @click="addRowRange()">+</a>
              </div>

              <div v-for="(row, index) in fieldValues" :key="index" :row="row">
                <div class="row">
                  <div class="col-md-12 d-flex">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>От</label>
                        <input type="text" class="form-control" v-model="row.value.from" spellcheck="true"/>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>До</label>
                        <div class="d-flex">
                          <input type="text" class="form-control" v-model="row.value.to" spellcheck="true"/>
                          <a class="btn btn-danger ml-2 cursor" @click="deleteRowRange(index)">X</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ******** RANGEBLOCK ******** -->

            <!-- ******** CHECKBOXBLOCK ******** -->
            <div id="CheckBoxBlock"
                 v-if="['checkbox', 'radio', 'multiselect'].includes(field.inputType)">
              <div class="w-100 d-flex justify-content-sm-between">
                <h2>{{field.inputType}}</h2>
                <a class="btn btn-success cursor" @click="addRowCheckBox()">+</a>
              </div>

              <div v-for="(row, index) in fieldValues" :key="index" :row="row">
                <div class="row">.
                  <div class="col-md-12 d-flex">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Значение</label>
                        <div class="d-flex">
                          <input type="text" class="form-control" v-model="row.value" spellcheck="true"/>
                          <a class="btn btn-danger ml-2 cursor" @click="deleteRowCheckBox(index)">X</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ******** CHECKBOXBLOCK ******** -->
          </ValidationObserver>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',false)">Закрыть</button>
            <button class="modal-button btn btn-success" @click="fieldStore()">Добавить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {POST, GET} from "@/shared/api";

export default {
  props: {
    clickedProductId:null,
    selectedProduct: {
      code: null,
      title: null
    },
    showFieldModal: false,
    units: [],
  },
  data() {
    return {
      product_id: null,
      product_prefetched: [],
      product_fields: [],
      selectedField: null,
      searchField: false,
      product_search: "",
      field: {},
      fieldTypes: [
        {
          id: 1,
          value: "range",
          title: "Диапазон"
        },
        {
          id: 2,
          value: "checkbox",
          title: "Несколько из нескольких (checkbox)"
        },
        {
          id: 3,
          value: "boolean",
          title: "Да Нет (Boolean)"
        },
        {
          id: 4,
          value: "radio",
          title: "Один из нескольких (radio)"
        },
        {
          id: 5,
          value: "text",
          title: "Текстовое поле (text)"
        },
        {
          id: 6,
          value: "number",
          title: "Числовое поле (number)"
        },
        {
          id: 7,
          value: "multiselect",
          title: "один из многих"
        },
      ],
      fieldValues: [],
      lockWatch: false,
      possibleTitles: [
        "Вид",
        "Наименование",
        "Тип",
        "Категория",
        "Класс",
        "Группа",
        "Сорт",
        "Упаковка",
        "Вид потребительской тары",
        "Дозировка",
        "Лекарственная форма"
      ],
    }
  },
  methods: {
    updateTab(event = 'update', spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
    fieldStore() {
      this.$refs.fieldStoreValidate.validate().then(success => {
        if (success && this.clickedProductId !== null) {
          this.field.values = this.fieldValues;
          this.field.product_id = this.clickedProductId;
          POST(this.field, "/field", this).then(() => {
            this.updateTab('update',{state:"success"})
          })
          .catch(() => {
            this.updateTab('update',{state:"err"})
          });
        }
      })
    },
    addRowRange() {
      this.fieldValues.push({value: {from: "", to: ""}});
    },
    deleteRow(index) {
      if (typeof this.fieldValues[index].state !== 'undefined') {
        if (this.fieldValues[index].state === "A") {
          this.fieldValues[index].state = "P";
        } else {
          this.fieldValues[index].state = "A";
        }
      } else {
        this.fieldValues.splice(index, 1);
      }
    },
    addRowCheckBox() {
      this.fieldValues.push({value: ""});
    },
    deleteRowCheckBox(index) {
      this.fieldValues.splice(index, 1);
    },
    addRowRange() {
      this.fieldValues.push({value: {from: "", to: ""}});
    },
    deleteRow(index) {
      if (typeof this.fieldValues[index].state !== 'undefined') {
        if (this.fieldValues[index].state === "A") {
          this.fieldValues[index].state = "P";
        } else {
          this.fieldValues[index].state = "A";
        }
      } else {
        this.fieldValues.splice(index, 1);
      }
    },
    addRowCheckBox() {
      this.fieldValues.push({value: ""});
    },
    deleteRowCheckBox(index) {
      this.fieldValues.splice(index, 1);
    },
    searchProduct(){
      if(this.product_search){
        GET({search: this.product_search}, "/prefetch", this, false, false).then((result)=>{
          this.product_prefetched = result.data;
        })
      }
    },
    loadProductFields(){
      if(this.product_id){
        GET([], "/getFieldsByProductId/"+this.product_id, this, false, false).then((result) => {
          this.product_fields = result.fields.filter((field)=> field.index != 0 ? field : false);
          console.log(this.product_fields)
        })
      }
    },
    applyField(){
      this.$set(this.field, 'ru_title', this.selectedField.title);
      this.$set(this.field, 'ru_comment', this.selectedField.comment);
      if(this.selectedField.unit_id)
        this.$set(this.field, 'unit_id', this.selectedField.unit_id);
      this.$set(this.field, 'isRequired', this.selectedField.isRequired);
      this.$set(this.field, 'inputType', this.selectedField.inputType);
      this.fieldValues = [];
      if(this.field.inputType === 'range'){
        this.selectedField.values.forEach((el) => {
          let value = JSON.parse(el);
          this.fieldValues.push({value : value});
        });
      }else{
        this.selectedField.values.forEach((el) => {
          this.fieldValues.push({value: el});
        });
      }
    },
    showFindFieldPart(){
      this.searchField = !this.searchField;
      if(!this.searchField){
        this.selectedField = null;
        this.fieldValues = [];
      }
    }
  },
  mounted() {
  },
  watch: {
    'field.inputType': function() {
      if(!this.selectedField)
        this.fieldValues = [];
    }
  }
}
</script>

<style scoped>

</style>
